export const PERCENT_LABEL_MAX_WIDTH = 36;

export const PROGRESS_GAP_SPACING = 0.75;

export const AMOUNTS_CONVERSION_GAP_SPACING = 1.5;
